import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IButtonProps } from '../components/button/button';
import { ISectionHeaderProps } from '../components/section-header/section-header';
import { ButtonModel } from './button-model';
import { SectionHeaderModel } from './section-header-model';

export interface IBlogAuthorListModelProps {
  header: ISectionHeaderProps;
  button: IButtonProps;
  showAllAuthors: boolean;
}

export class BlogAuthorListModel extends ContentItem {
  get header(): ISectionHeaderProps {
    const header = get(this._config, 'elements.header.value[0]', '');
    const modeledHeader = header && SectionHeaderModel.create(header);
    return modeledHeader;
  }

  get button(): IButtonProps {
    const getButton = get(this._config, 'elements.button.value[0]', null);

    const transformButton = getButton ? ButtonModel.create(getButton) : null;
    return transformButton as IButtonProps;
  }

  get showAllAuthors(): boolean {
    return get(this._config, 'elements.show_all_authors.value[0].name', false);
  }

  public static create(data: IBlogAuthorList): IBlogAuthorListModelProps {
    const { header, button, showAllAuthors } = new BlogAuthorListModel(data);

    return {
      header,
      button,
      showAllAuthors
    };
  }
}
